import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';
import ReactPlaceholder from 'react-placeholder';
import {
  Form, H4, Subtext,
  DragAndDropPlaceholder,
  DeleteConfirmation
} from '@contently/toolkit';
import { FieldArray } from 'formik';
import QuestionField from '../questions/QuestionField';

const CustomQuestions = (props) => {
  const {
    questions,
    onDragEnd,
    onDelete,
    setFieldValue,
    arrayHelpers
  } = props;

  const [confirmDeleteIndex, setConfirmDeleteIndex] = useState();
  const showConfirmDelete = (index) => { setConfirmDeleteIndex(index); }
  const hideConfirmDelete = () => setConfirmDeleteIndex(null);

  const onConfirmDelete = (questionIndex) => {
    onDelete(questionIndex, arrayHelpers);
    hideConfirmDelete();
  }

  if (questions && questions.length) {
    return (
      <Form.DragAndDrop.Container
        onDragEnd={result => onDragEnd(result, arrayHelpers)}
        onDelete={showConfirmDelete}
      >
        {questions &&
          questions.map((question, index) => (
            <DeleteConfirmation
              key={`delete-confirmation-${index}`}
              isOpen={confirmDeleteIndex == index}
              onCancel={hideConfirmDelete}
              onDelete={() => onConfirmDelete(index)}
              size="short"
            >
              <QuestionField
                question={question}
                index={index}
                key={index.toString()}
                setFieldValue={setFieldValue}
              />
            </DeleteConfirmation>
          ))}
      </Form.DragAndDrop.Container>
    );
  }
  return <Subtext>This content request does not have any custom questions.</Subtext>;
};

CustomQuestions.propTypes = {
  questions: PropTypes.array,
  onDragEnd: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  setFieldValue: PropTypes.func.isRequired,
  arrayHelpers: PropTypes.object
};

CustomQuestions.defaultProps = {
  questions: []
};

const QuestionsContainer = (props) => {
  const {
    questions,
    isFetching
  } = props;

  return (
    <FieldArray
      name="questions"
      render={arrayHelpers => (
        <Fragment>
          <H4>Custom Question Fields</H4>
          <ReactPlaceholder
            showLoadingAnimation
            customPlaceholder={<DragAndDropPlaceholder/>}
            ready={!isFetching}
          >
            <CustomQuestions
              arrayHelpers={arrayHelpers}
              {...props}
            />
          </ReactPlaceholder>
          <div className="row-fourth">
            <Form.Button
              type="button"
              onClick={() => arrayHelpers.insert(questions.length, { label: '', value: '', required: false })}
              variant="secondary"
              size="small"
            >
              Add Question
            </Form.Button>
          </div>
        </Fragment>
      )}
    />
  );
};

QuestionsContainer.propTypes = {
  questions: PropTypes.array,
  onDragEnd: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  setFieldValue: PropTypes.func.isRequired,
  isFetching: PropTypes.bool.isRequired,
};

QuestionsContainer.defaultProps = {
  questions: []
};

export default QuestionsContainer;



// WEBPACK FOOTER //
// ./app/javascript/app/components/content_request_forms/questions_container.jsx